import { SimpleBars } from '../../../Common/Charts/SimpleBars';
import { useCausesCondictionsChartsDataContext } from './hooks/useCausesCondictionsChartsDataContext';

export const ConfirmationByNecropsy = () => {
    const { chartData } = useCausesCondictionsChartsDataContext();


    return (
        <SimpleBars
            title={'Confirmação por Necropsia'}
            horizontal={false}
            subtitles={chartData?.confirmationByNecropsy?.map((item) => item.description)}
            values={chartData?.confirmationByNecropsy?.map((item) => item.total  ||  0)}
        />
    );
};
